'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _neptune = require('./neptune');

var _neptune2 = _interopRequireDefault(_neptune);

var _n2 = require('./_n');

var _n3 = _interopRequireDefault(_n2);

var _uson = require('../../node_modules/uson');

var _uson2 = _interopRequireDefault(_uson);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_neptune2.default.stratosphere = {

  init: function init(p) {

    window.dataLayer = window.dataLayer || [];

    p = p || document;

    _n3.default.qsa('[neptune-stratosphere]:not([neptune-stratosphere-processed])', p).forEach(function (el, i) {

      try {

        el.stratosphere = _uson2.default.parse(el.getAttribute('neptune-stratosphere'))[0];

        if (el.stratosphere.data.position == 'auto') el.stratosphere.data.position = i + 1;

        if (!!el.stratosphere.awaitChildren) return false;

        setTimeout(function () {
          _neptune2.default.stratosphere.process(el);
        }, el.stratosphere.delay || 0);
      } catch (err) {/* debug */}
    });
  },
  process: function process(el) {

    if (!el.stratosphere) return false;

    if (!!el.stratosphere.events) {
      el.stratosphere.events.forEach(function (evt) {

        if (evt.on == 'load' || !evt.on) {
          window.dataLayer.push(JSON.parse(JSON.stringify(evt.push).replace('"_this"', JSON.stringify(el.stratosphere.data))));
        } else {
          el.addEventListener(evt.on, function (e) {
            window.dataLayer.push(JSON.parse(JSON.stringify(evt.push).replace('"_this"', JSON.stringify(el.stratosphere.data))));
          });
        }
      });
    }

    // ascend to parent
    if (!!el.stratosphere.parent && !!el.stratosphere.data) {

      if (!_n3.default.parents(el, '[neptune-stratosphere]', true)) return false;
      try {
        el.stratosphere.parent.split('.').reduce(function (o, i) {
          return o[i];
        }, _n3.default.parents(el, '[neptune-stratosphere]', true).stratosphere.data).push(el.stratosphere.data);
      } catch (err) {}
      // if it's the last child of a parent that is awaiting children, process the parent
      if (_n3.default.array(_n3.default.qsa('[neptune-stratosphere]:not([neptune-stratosphere-processed])', _n3.default.parents(el, '[neptune-stratosphere*=awaitChildren]', true))).reverse()[0] == el) {
        _neptune2.default.stratosphere.process(_n3.default.parents(el, '[neptune-stratosphere*=awaitChildren]', true));
      }
    }

    el.setAttribute('neptune-stratosphere-processed', true);
  }

};
window.Neptune = _neptune2.default;

exports.default = _neptune2.default.stratosphere;